<template>
  <div id="login-card">
    <div class="text-danger text-center" v-if="message">
      {{message}}
    </div>
    <form @submit="submitSignIn">
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="email"><h3>Email</h3></label>
          <div class="row">
            <i class="fa fa-envelope col-2 icon fa-2x"></i> 
            <input type="email" class="form-control col-10" placeholder="Example@Email.com"  v-model="credentials.email" required/>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="password"><h3>Password</h3></label>
          <div class="row">
            <i class="fa fa-lock col-2 icon fa-2x"></i> 
            <input type="password" class="form-control col-10"  v-model="credentials.password" required/>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <router-link to="forgot_password">Forgot Password?</router-link>
      </div>
      <div class="row justify-content-center">
        <router-link to="resend_confirmation">Resend Confirmation Email</router-link>
      </div>
      <br/>
      <div v-if="fedramp" class="row justify-content-center">
        <b-button @click="displaySystemUse" class="btn btn-primary col-sm-6">Continue to Log In</b-button>
        <b-modal ref="system-use-login" id="modal-2" class="my-modal" title="System Use Notification" hide-footer size="lg">
          <div class="text-center">
            <h4>This is a notice that you are accessing a U.S. Government information system.</h4>
            <p>Information system usage may be monitored, recorded, and subject to audit.</p>
            <p>Unauthorized use of the information system is prohibited and subject to criminal and civil penalties.</p>
            <p>Use of the information system indicates consent to monitoring and recording.</p>
            <h4>Authorized Usage:</h4>
            <p>List all authorized uses of the information system.</p>
            <button @click="submitSignIn" type="submit" pattern=".*\S+.*" title="This field is required" class="btn col-sm-6 btn-primary" >Agree and Log In</button>
            <div v-if="message">
              <p class="text-danger small">Invalid credentials. Please try again.</p>
            </div>
          </div>
        </b-modal>
      </div>
      <div v-else class="row justify-content-center ">
        <button type="submit" class="btn col-sm-6 btn-primary log-in">Log In</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from '../../auth.js'
export default {
  props: {
    nextPath: String
  },
  data(){
    return {
      fedramp: null,
      credentials: {
          email: '',
          password: ''
      },
      message: null
    }
  },
  mounted(){
    if (process.env.VUE_APP_FEDRAMP === "true") {
      this.fedramp = true
    } else {
      this.fedramp = false
    }


    if (this.$route && this.$route.query.notify) {
      this.$toasted.success(this.$route.query.notify,
        {
          position: "bottom-right",
          duration: 10000
        })
    }
    // get request to set token before we post
    axios.get(
      `${process.env.VUE_APP_ENDPOINT}/users/sign_in/`
    )
  },
  methods:{
    displaySystemUse() {
      if (this.credentials.email && this.credentials.password) {
        this.$refs['system-use-login'].show()
      }
    },
    submitSignIn(event){
      event.preventDefault()
      axios.get(
        `${process.env.VUE_APP_ENDPOINT}/users/sign_in/`
      ).then(() => {
        axios.post(
          `${process.env.VUE_APP_ENDPOINT}/users/sign_in/`,
          { "user": this.credentials }
        )
        .then(res =>{
          localStorage.setItem("loggedIn", true)
          this.$store.commit('login', true)
          this.$store.commit('setUserName', res.data.first_name)
          if (this.$store.state.afterLoginPath.includes("reset_password") || this.$props.nextPath.includes("reset_password")){
            this.$router.push("/")
          } else if (this.$store.state.afterLoginPath === "/") {
            this.$router.push(this.$props.nextPath)
          } else {
            this.$router.push(this.$store.state.afterLoginPath)
          }
        })
        .catch(e => {
          this.message = e.response.data.error
          localStorage.setItem("loggedIn", false)
          this.$store.commit('login', false)
          this.$store.commit('setUserName', null)
        //  this.$store.commit('setProfileData', {})
        })
      })
    }
  }
}
</script>

<style scoped>

label {
  margin-bottom: 0px;
  margin-top: 1em;
}

.icon {
  color: #dcdcdc;
}

</style>
